import querystring from "querystring";
import React from "react";
import {useI18N} from "../../../my-puratos/hoc/withI18N";
import {ITagLink} from "../product-stencil.types";

export const BenefitLabel = ({key = 0, benefit}: { key?: number; benefit: ITagLink }) => {
    const translate = useI18N();
    const {title, url, path, colour} = benefit;
    const benefitUrl = path ? `${url}?tag=${encodeURIComponent(path)}` : url;
    const benefitColourClass = colour ? `pdp-badge--${colour}` : '';

    return (
        <span className={`pdp-badge ${benefitColourClass}`} key={key}>
            <a href={benefitUrl} key={key}>
                {translate(title)}
            </a>
        </span>
    )
}
